// extracted by mini-css-extract-plugin
export default {"header-container":"Detail_header-container__9KS-7","flex":"Detail_flex__hmLPU","order-btn":"Detail_order-btn__Htv5d","table":"Detail_table__7LdAv"};